angular.module('FmsApp').factory("FileUploadResource", function ($resource) {
    return $resource('/api/upload');
});
